const CopyIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.50008 18.958H6.33341C2.67508 18.958 1.04175 17.3247 1.04175 13.6663V10.4997C1.04175 6.84134 2.67508 5.20801 6.33341 5.20801H8.83341C9.17508 5.20801 9.45841 5.49134 9.45841 5.83301C9.45841 6.17467 9.17508 6.45801 8.83341 6.45801H6.33341C3.35008 6.45801 2.29175 7.51634 2.29175 10.4997V13.6663C2.29175 16.6497 3.35008 17.708 6.33341 17.708H9.50008C12.4834 17.708 13.5417 16.6497 13.5417 13.6663V11.1663C13.5417 10.8247 13.8251 10.5413 14.1667 10.5413C14.5084 10.5413 14.7917 10.8247 14.7917 11.1663V13.6663C14.7917 17.3247 13.1584 18.958 9.50008 18.958Z"
        fill="#010D1D"
      />
      <path
        d="M14.1668 11.7921H11.5002C9.1585 11.7921 8.2085 10.8421 8.2085 8.5004V5.83373C8.2085 5.58373 8.3585 5.3504 8.59183 5.25873C8.82516 5.15873 9.09183 5.21706 9.27516 5.39206L14.6085 10.7254C14.7835 10.9004 14.8418 11.1754 14.7418 11.4087C14.6502 11.6421 14.4168 11.7921 14.1668 11.7921ZM9.4585 7.34206V8.5004C9.4585 10.1587 9.84183 10.5421 11.5002 10.5421H12.6585L9.4585 7.34206Z"
        fill="#010D1D"
      />
      <path
        d="M13.0001 2.29199H9.66675C9.32508 2.29199 9.04175 2.00866 9.04175 1.66699C9.04175 1.32533 9.32508 1.04199 9.66675 1.04199H13.0001C13.3417 1.04199 13.6251 1.32533 13.6251 1.66699C13.6251 2.00866 13.3417 2.29199 13.0001 2.29199Z"
        fill="#010D1D"
      />
      <path
        d="M5.83325 4.79199C5.49159 4.79199 5.20825 4.50866 5.20825 4.16699C5.20825 2.44199 6.60825 1.04199 8.33325 1.04199H10.5166C10.8583 1.04199 11.1416 1.32533 11.1416 1.66699C11.1416 2.00866 10.8583 2.29199 10.5166 2.29199H8.33325C7.29992 2.29199 6.45825 3.13366 6.45825 4.16699C6.45825 4.50866 6.17492 4.79199 5.83325 4.79199Z"
        fill="#010D1D"
      />
      <path
        d="M15.9917 14.792C15.65 14.792 15.3667 14.5087 15.3667 14.167C15.3667 13.8253 15.65 13.542 15.9917 13.542C16.9417 13.542 17.7084 12.767 17.7084 11.8253V6.66699C17.7084 6.32533 17.9917 6.04199 18.3334 6.04199C18.675 6.04199 18.9584 6.32533 18.9584 6.66699V11.8253C18.9584 13.4587 17.625 14.792 15.9917 14.792Z"
        fill="#010D1D"
      />
      <path
        d="M18.3333 7.29174H15.8333C13.6166 7.29174 12.7083 6.38341 12.7083 4.16674V1.66674C12.7083 1.41674 12.8583 1.18341 13.0916 1.09174C13.3249 0.991739 13.5916 1.05007 13.7749 1.22507L18.7749 6.22507C18.9499 6.40007 19.0083 6.67507 18.9083 6.90841C18.8166 7.14174 18.5833 7.29174 18.3333 7.29174ZM13.9583 3.17507V4.16674C13.9583 5.69174 14.3083 6.04174 15.8333 6.04174H16.8249L13.9583 3.17507Z"
        fill="#010D1D"
      />
    </svg>
  );
};

export default CopyIcon;
